import MenuIcon from '@material-ui/icons/Menu';
import { createElement } from 'react';
import { renderReactElement } from './renderReactElement.esm.js';

const addSidebarToggle = () => {
  return (dom) => {
    const mkdocsToggleSidebar = dom.querySelector(
      '.md-header label[for="__drawer"]'
    );
    const article = dom.querySelector("article");
    if (!mkdocsToggleSidebar || !article) {
      return dom;
    }
    const toggleSidebar = mkdocsToggleSidebar.cloneNode();
    renderReactElement(createElement(MenuIcon), toggleSidebar);
    toggleSidebar.id = "toggle-sidebar";
    toggleSidebar.title = "Toggle Sidebar";
    toggleSidebar.classList.add("md-content__button");
    toggleSidebar.style.setProperty("padding", "0 0 0 5px");
    toggleSidebar.style.setProperty("margin", "0.4rem 0 0.4rem 0.4rem");
    article?.prepend(toggleSidebar);
    return dom;
  };
};

export { addSidebarToggle };
//# sourceMappingURL=addSidebarToggle.esm.js.map
